import { IDonorShieldDirect } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IDonorShieldDirect,
    container: any,
    onDelete: () => void,
    onCancel: () => void
}

const DeleteDonorShieldDirectConfirmation = (props: IProps) => {
    if (props.data == null)
        return null;

    let { donorAlias, recipientAlias } = props.data;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel} container={props.container}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Donor Shield Direct Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ textAlign: 'center', marginBottom: 10 }}>Are you sure you want to delete the following entry?</div>
                <div style={{ textAlign: 'center' }}><strong>{donorAlias}</strong> &gt;&gt; <strong>{recipientAlias}</strong></div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onDelete}>Yes, Confirm Deletion</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteDonorShieldDirectConfirmation;